import store from '@/store';
import * as OM from '@/model';

function validateDate(inputDate: string){
    let date = new Date(inputDate);
    if(isValidDate(date)){
        let years = date.getFullYear().toString();
        while(years.length < 4){
            years = "0" + years;
        } 
        let months = (date.getMonth() + 1).toString();
        if(months.length < 2) months = "0" + months;
        let days = date.getDate().toString();
        if(days.length < 2) days = "0" + days;
        return years +  "-" + months + "-" + days;
    }
}
export function isValidDate(d: any) {
    return d instanceof Date && !isNaN(<any>d);
}


